import en from './en.json';
import fr from './fr.json';

export const contractsI18n = {
  fr,
  en,
};
